
import {defineComponent, ref, watchEffect} from 'vue';
import Text from '@ohrm/oxd/core/components/Text/Text.vue';
import Divider from '@ohrm/oxd/core/components/Divider/Divider.vue';
import IconButton from '@ohrm/oxd/core/components/Button/Icon.vue';
import useResponsive, {
  DEVICE_LG,
  DEVICE_XL,
} from '../../../composables/useResponsive';

export default defineComponent({
  name: 'oxd-table-filter',

  components: {
    'oxd-text': Text,
    'oxd-divider': Divider,
    'oxd-icon-button': IconButton,
  },

  props: {
    filterTitle: {
      type: String,
      required: true,
    },
  },

  setup() {
    const responsiveState = useResponsive();
    const isActive = ref(true);

    const toggleFilters = () => {
      isActive.value = !isActive.value;
    };

    watchEffect(() => {
      isActive.value =
        responsiveState.screenType === DEVICE_LG ||
        responsiveState.screenType === DEVICE_XL;
    });

    return {
      isActive,
      toggleFilters,
    };
  },
});
